import type { IBuildingCard } from 'shared/types/buildingCard';

/** Имя здания, у корпуса — вместе с именем основного здания. Порт `get_bs_center_name` монолита */
export function getBuildingName(card: IBuildingCard): string {
  const name = card.name ?? '';

  if (card.parentId && card.parent?.name && card.useParentName) {
    return `${card.parent.name} (${name})`;
  }

  return name;
}
